import swLog from "@similarweb/sw-log";
import {
    MatomoTracker,
    ConsoleTracker,
    GoogleTracker,
    AggregatedTracker,
    BaseTracker,
    MixpanelTracker,
} from "@similarweb/sw-track";

declare const SW_ENV: { debug: boolean; version: string };

class AccountMatomoTracker extends MatomoTracker {
    paq() {
        return window["_matomoPaq"];
    }

    shouldBuffer() {
        return false;
    }

    searchParams() {
        return {};
    }

    isEnabled() {
        return !SW_ENV.debug;
    }
}

class AccountGATracker extends GoogleTracker {
    protected ga(): (...params) => void {
        return window.parent["ga"];
    }

    protected isEnabled(): boolean {
        return !SW_ENV.debug;
    }
}

class AccountMixpanelTracker extends MixpanelTracker {
    protected mixpanel() {
        return window["mixpanel"];
    }

    protected isEnabled(): boolean {
        return !SW_ENV.debug;
    }
}

class AccountGTMTracker extends BaseTracker {
    protected dataLayer(): any[] {
        return window["dataLayer"];
    }

    isEnabled(): boolean {
        return !SW_ENV.debug;
    }

    healthCheckInternal() {
        if (!SW_ENV.debug && !window["dataLayer"]) {
            swLog.serverLogger("GTM is not loaded", null, "Info");
        }
    }

    trackEventInternal({ action, name, trackId, location }) {
        const dataLayer = this.dataLayer();
        if (dataLayer) {
            dataLayer.push({ event: [name, trackId, location, action].join("/") });
        }
    }

    trackPageViewInternal() {
        return;
    }
}

export const track = new AggregatedTracker([
    new AccountMatomoTracker(),
    new AccountGATracker(),
    new AccountMixpanelTracker(),
    new AccountGTMTracker(),
    new ConsoleTracker("Tracker"),
]);
